export interface AuthState {
  email: string | null;
}

export const INITIAL_AUTH_STATE: AuthState = {
  email: null,
};
